import { SurveyQuota } from '../../models/survey-quota.model';

/**
 * Orders one qualification's quotas the way legacy does by default —
 * ascending by the first criterion's range upper bound, with any
 * discrete-condition quota (e.g. Male/Female) sorted after every ranged one.
 * Mirrors manage-quotas.component.ts:709-723 (`_updateQuotaPosition`),
 * adapted for this model: legacy's `if (quota1.criteria[0].condition_codes)`
 * relies on the field being entirely absent from a range criterion's DTO, but
 * this model's QuotaCriteria always carries `conditionCodes` as an array —
 * so a non-empty array is the equivalent signal here.
 */
export function sortQuotaGroupByPosition(
  quotas: readonly SurveyQuota[],
): SurveyQuota[] {
  return [...quotas].sort((first, second) => {
    const firstCriterion = first.criteria[0];
    if (firstCriterion?.conditionCodes?.length) {
      return 1;
    }
    const firstTo = firstCriterion?.rangeSets?.[0]?.to ?? 0;
    const secondTo = second.criteria[0]?.rangeSets?.[0]?.to ?? 0;
    return firstTo - secondTo;
  });
}
